import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#008544',
        secondary: '#990000',
        accent: '#008891'
      }
    }
  }
})
